import { render, staticRenderFns } from "./signPhone.vue?vue&type=template&id=94be38aa&"
import script from "./signPhone.vue?vue&type=script&lang=js&"
export * from "./signPhone.vue?vue&type=script&lang=js&"
import style0 from "./signPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports